var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2502 1.59236C13.2502 1.77535 13.1772 1.95834 13.0307 2.09797L7.53123 7.33939C7.23873 7.61864 6.76373 7.61864 6.47073 7.33939L0.970727 2.09796C0.677727 1.81871 0.677727 1.36648 0.970727 1.08723C1.26323 0.807979 1.73823 0.807979 2.03123 1.08723L7.00073 5.82305L11.9697 1.08723C12.2627 0.807981 12.7372 0.807981 13.0302 1.08723C13.1772 1.22638 13.2502 1.40937 13.2502 1.59236Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.843f575383342aaf1749251782bad0eb.svg";
export { ForwardRef as ReactComponent };